<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora FICOHSA </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <v-text-field
                v-model="expediente"
                label="Expediente"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="expediente_dis"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="atencion"
                label="Atención"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="atencion_dis"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="validarId()" v-if="campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_ficohsa: 0,
      expediente: "",
      atencion: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      ////
      expediente_dis: false,
      atencion_dis: false,
    };
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreFicohsa/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_ficohsa = response.data[0].id_cierre_ficohsa;
            this.expediente = response.data[0].expediente;
            this.atencion = response.data[0].atencion;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (this.expediente.length > 0 && this.atencion.length > 0) {
              this.campos_completos = false;
            }

            if (this.expediente.length > 0) {
              this.expediente_dis = true;
            }
            if (this.atencion.length > 0) {
              this.atencion_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_ficohsa == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_ficohsa > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreFicohsa/Crear",
          {
            idCabina: this.id_cabina,
            expediente: this.expediente,
            atencion: this.atencion,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreFicohsa/Actualizar",
              {
                id_cierre_ficohsa: this.id_cierre_ficohsa,
                idCabina: this.id_cabina,
                expediente: this.expediente,
                atencion: this.atencion,
              },
              configuracion
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreFicohsa/Actualizar",
            {
              id_cierre_ficohsa: this.id_cierre_ficohsa,
              idCabina: this.id_cabina,
              expediente: this.expediente,
              atencion: this.atencion,
            },
            configuracion
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_ficohsa = 0;
      this.expediente = "";
      this.atencion = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>